export default "__VITE_ASSET__DwH22IrC__"